import { render } from "./ProductRevenuebySegment.vue?vue&type=template&id=2a01da12"
import script from "./ProductRevenuebySegment.vue?vue&type=script&lang=js"
export * from "./ProductRevenuebySegment.vue?vue&type=script&lang=js"

import "./ProductRevenuebySegment.vue?vue&type=style&index=0&id=2a01da12&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__